'use client';

import { useEffect, useState } from 'react';

type HoverCardListener = (openId: string | null) => void;

type HoverCardCoordinator = {
  getCurrent: () => string | null;
  subscribe: (listener: HoverCardListener) => () => void;
  open: (id: string) => void;
  close: (id: string) => void;
};

const listeners = new Set<HoverCardListener>();
let currentOpenId: string | null = null;

const coordinator: HoverCardCoordinator = {
  getCurrent: () => currentOpenId,
  subscribe(listener) {
    listeners.add(listener);
    listener(currentOpenId);
    return () => {
      listeners.delete(listener);
    };
  },
  open(id) {
    if (currentOpenId === id) return;
    currentOpenId = id;
    for (const listener of listeners) listener(currentOpenId);
  },
  close(id) {
    if (currentOpenId !== id) return;
    currentOpenId = null;
    for (const listener of listeners) listener(currentOpenId);
  },
};

export function useActiveHoverId(initialId: string | null) {
  const [activeHoverId, setActiveHoverId] = useState<string | null>(initialId);
  useEffect(() => coordinator.subscribe(setActiveHoverId), []);
  return activeHoverId;
}

export function useHoverCardCoordinator() {
  return coordinator;
}

export type { HoverCardCoordinator };
